import { observer } from 'mobx-react-lite';
import Image from 'next/legacy/image';
import IconSymplaPlay from '@sympla/sympla-ui/lib/icons/iconSymplaPlay';
import { SearchEvent } from 'searchEvent.d';
import { DEFAULT_IMAGE } from 'constants/index';
import * as El from '../EventCard/EventCard.style';
import { LogoWrapper } from './EventOndemandCard.style';

type EventOndemandCardProps = {
  hasPriority?: boolean
} & SearchEvent

function EventOndemandCard({
  name,
  images,
  url,
  organizer,
  hasPriority,
}: EventOndemandCardProps) {
  return (
    <El.Card href={url}>
      <Image
        src={images?.xs || DEFAULT_IMAGE}
        alt={`Banner ${name}`}
        width={264}
        height={134}
        priority={hasPriority}
      />
      <El.InfoContainer>
        <LogoWrapper>
          <IconSymplaPlay height={24} width={81} />
        </LogoWrapper>
        <h3>{name}</h3>
        <El.Location>{`Por ${organizer?.name}`}</El.Location>
      </El.InfoContainer>
    </El.Card>
  );
}

export default observer(EventOndemandCard);
